export const envConfig = {
  GET_CLIENTS: `${process.env.REACT_APP_API_URL}/app/user/clients`,
  ENTITIES_TO_CLIENT: `${process.env.REACT_APP_API_URL}/app/client/entities`,
  ONLINE_NEWS_TO_ENTITY: `${process.env.REACT_APP_API_URL}/app/articles/newsearch`,
  TV_NEWS: `${process.env.REACT_APP_API_URL}/app/articles/newsearch_electronic`,
  TV_NEWSLIST: `${process.env.REACT_APP_API_URL_TV}/social-feeds/get-tvclipsrowlist`, 
  TV_NEWSSINGLE: `${process.env.REACT_APP_API_URL_TV}/social-feeds/get-singletvclip`, 
  PRINT_NEWS_TO_ENTITY: `${process.env.REACT_APP_API_URL}/app/articles/newsearch`,
  KEYWORDS_TO_ENTITY: `${process.env.REACT_APP_API_URL}/app/client/entity_keywords`,
  PUBLICATION_TYPES_LIST: `${process.env.REACT_APP_API_URL}/app/search/publication_types`,
  PUBLICATION_SEARCH: `${process.env.REACT_APP_API_URL}/app/search/publications`,
  REPORTER_SEARCH: `${process.env.REACT_APP_API_URL}/app/search/reporter`,
  EDITIONS_LIST: `${process.env.REACT_APP_API_URL}/app/search/editions`,
  ZONES: `${process.env.REACT_APP_API_URL}/app/search/zones`,
  REPORTER: `${process.env.REACT_APP_API_URL}/app/search/reporter`,
  REPORTS: `${process.env.REACT_APP_API_URL}/app/reports/data`,
  CATEGORIES: `${process.env.REACT_APP_API_URL}/app/client/categories_list`,
  PRESS_RELEASE: `${process.env.REACT_APP_API_URL}/app/client/pressrelease_list`,
  ARTICLES_IMAGE_BASE_URL:
    "https://backendportal.conceptbiu.com/assets/articles_image",
  KEYWORDS_TAGS_LIST: `${process.env.REACT_APP_API_URL}/app/articles/keyword_list`,
  PRINT_DETAILS: `${process.env.REACT_APP_API_URL}/app/articles/details`,
  ONLINE_DETAILS: `${process.env.REACT_APP_API_URL}/app/online_articles/details`,
  PRINT_ONLINE_SHARE_ARTICLE: `${process.env.REACT_APP_API_URL}/app/share/articlestest`,
  TV_SHARE_ARTICLE: `${process.env.REACT_APP_API_URL}/app/share/articles_electronic`,
  SOCIAL_SHARE_ARTICLE: `${process.env.REACT_APP_API_URL}/app/share/articles`,
  DOWNLOAD_ARTICLE_FOR_ONE: `${process.env.REACT_APP_API_URL}/app/newdownloads/search_result_single`,
  DOWNLOAD_ARTICLE: `${process.env.REACT_APP_API_URL}/app/newdownloads/search_result`,
  DOWNLOAD_ARTICLE_FOR_TV: `${process.env.REACT_APP_API_URL}/app/newdownloads/search_result_electronic`,
  ONLINE_ARTICLES_LIST: `${process.env.REACT_APP_API_URL}/app/online_articles/list_all`,
  PRINT_ARTICLES_LIST: `${process.env.REACT_APP_API_URL}/app/articles/similar_article_list_all`,
  ONLINE_PRESS_RELEASE_LIST: `${process.env.REACT_APP_API_URL}/app/online_articles/pressrelease`,
  PRINT_PRESS_RELEASE_LIST: `${process.env.REACT_APP_API_URL}/app/articles/pressrelease`,
  ARTICLE_LIST: `${process.env.REACT_APP_API_URL}/app/articles/similar_article_list_all`,
  ARTICLE_TAG_LIST: `${process.env.REACT_APP_API_URL}/app/client/tag_component_list`,
  SET_ARTICLE_TAG: `${process.env.REACT_APP_API_URL}/app/articles/tag`,
  SET_ARTICLE_TAG_FOR_TV: `${process.env.REACT_APP_API_URL}/app/articles/tag_electronic`,
  WIDGET_INLINE_FILTER: `${process.env.REACT_APP_API_URL}/app/filters/data`,
  PUBLICATION_LOGO_BASE_URL:
    "https://clientportalold.conceptbiu.com/assets/masthead/",
  CHANGE_PASSWORD: `${process.env.REACT_APP_API_URL}/app/user/change_password`,
  SERVICE_ACCESS: `${process.env.REACT_APP_API_URL}/app/user/service_access`,
  ISAUTH: `${process.env.REACT_APP_API_URL}/app/article/authenticate_url`,
  CHANNELS_LIST: `${process.env.REACT_APP_API_URL}/app/search/electronic_channels `,
  REPORT_LIST: `${process.env.REACT_APP_API_URL}/app/search/electronic_anchors`,
  LANGUAGES_LIST: `${process.env.REACT_APP_API_URL}/app/search/all_languages`,
  NEW_PRINT_NEWS_TO_ENTITY: `${process.env.REACT_APP_API_URL}/app/articlesv1/entitywithcount`,
  NEW_PRINT_NEWS_TO_ENTITY_LIST: `${process.env.REACT_APP_API_URL}/app/articlesv1/entitydatawithpages`,
  DOWNLOAD_REPORTS: `${process.env.REACT_APP_API_URL}/app/client/clientreportdetails`,
  GET_STATE: `${process.env.REACT_APP_API_URL}/app/search/states`,
  CLIENT_LANGUAGE: `${process.env.REACT_APP_API_URL}/app/search/language`,
  SEARCH_STATE: `${process.env.REACT_APP_API_URL}/app/search/state_editions`,
};

export const unifiedEnvConfig = {
  ADD_DASHBOARD_NAME: "/unifiedapi/dashboards",
  GET_USER_PASSWORD_DETAILS: "/unifiedapi/auth/password-check",
  DEFAULT_DASHBOARD: "/unifiedapi/widgets/default",
  GET_DASHBOARDS_LIST: "/unifiedapi/dashboards",
  DELETE_DASHBOARD: "/unifiedapi/dashboards",
  LOGIN_URL: "/unifiedapi/auth/login",
  LOGOUT_URL: "/unifiedapi/auth/logout",
  ADD_TOPIC: "/unifiedapi/topics",
  SOCIAL_ACCOUNTS: "/unifiedapi/social-accounts/pages?page=1&perPage=20",
  SOCIAL_ACCOUNTS_AUTHORIZE: "/unifiedapi/social-accounts/authorize",
  LINKEDIN_ACCOUNTS_AUTHORIZE: "/unifiedapi/social-accounts/authorizelinkedin",
  LINKEDIN_ACCOUNTS_AUTHORIZE_CALLBACK: "/unifiedapi/social-accountv2/authorizelinkedincallback",
  FETCH_ALL_TOPICS: "/unifiedapi/topics",
  FETCH_SOCIAL_FEEDS: "/unifiedapi/social-feeds/multiple-topics",
  FETCH_SOCIAL_DASHBOARD_FEEDS:
    "/unifiedapi/social-feeds?client_id={client_id}&searchParams[type]={type}&page={page}&perPage={perPage}&searchParams[channel_type]=&searchParams[city]=&searchParams[min_comments]=&searchParams[from_date]={from_date}&searchParams[to_date]={to_date}&searchParams[topic_id]={topic_id}",
  FETCH_MORE_SOCIAL_FEEDS: "/unifiedapi/social-feeds",
  WIDGET: "/unifiedapi/widgets",
  SOCIAL_GRAPH: "/unifiedapi/widget-graphs",
  SHARE_ARTICLE: `/unifiedapi/social-feeds/social-share`,
  FETCH_ONE_TOPIC: "/unifiedapi/topics",
  FETCH_CITY: "/unifiedapi/social-feeds/cities",
  DELETE_TOPIC: "/unifiedapi/topics",
  COMMENTS:
    "/unifiedapi/social-feeds/comments/{feedId}?channel_type={channel_type}",
  URL_EXPIRE: "/unifiedapi/social-feeds/media-sources",
  SOCIAL_DAILY_FEEDS_LIST: "/unifiedapi/social-feeds/daily-feeds",
  SOCIAL_DAILY_FEED_COUNT_LIST:
    "/unifiedapi/social-feeds/daily-feed-count?client_id={clientId}",
  SOCIAL_FEED_DETAILS: "/unifiedapi/social-feeds/details/{id}/{channel_type}",
  SOCIAL_TV_FEED_DETAILS: "/tvclips/social-feeds/get-singletvclip/{id}",
  MAP_DATA: "/unifiedapi/world-maps",
  GET_TAGS_LIST: "/unifiedapi/tags?client_id={client_id}",
  CREATE_TAG: "/unifiedapi/tags",
  EDIT_TAG_NAME: "/unifiedapi/tags/{id}?client_id={client_id}",
  DELETE_TAG: "/unifiedapi/tags/{id}?client_id={client_id}",
  ADD_TAG_TO_FEED: "/unifiedapi/social-feed-tags",
  DELETE_TAG_FROM_FEED: "/unifiedapi/social-feed-tags",
  GET_FEEDS_BY_VERTICAL: "/unifiedapi/social-feeds/tagged/{id}",
  LANGUAGES: "/unifiedapi/social-feeds/languages",
  COUNTRIES: "/unifiedapi/social-feeds/countries",
  SOCIAL_UPDATE_SENTIMENTS: "/unifiedapi/social-feed-tonality",
  GET_FAVOURITES_LIST: "/unifiedapi/social-feeds/favourites",
  UPDATE_FAVOURITES_TAG: "/unifiedapi/social-feed-favourites",
  FEEDS_DOWNLOAD: "/unifiedapi/social-feeds/download",
  CLIENT_SETTING: "/unifiedapi/admin/client-setting",
  LIMIT: "unifiedapi/admin/client-setting",
  UPDATE_LIMIT: "unifiedapi/client-setting/limit",
  TWITTER_BREAKDOWN: "unifiedapi/social-feeds/tweets-breakdown",
  BREAKDOWN: "unifiedapi/social-feeds/article-breakdown",
  TWITTER_FEEDS: "unifiedapi/social-feeds/top-retweets",
  INSIGHT_FEEDS: "unifiedapi/social-feeds/top-reshares",
  TWITTER_METRICS: "unifiedapi/social-feeds/key-matrices",
  INSIGHT_METRICS: "unifiedapi/social-feeds/key-matrices-platformwise",
  FETCH_SOCIAL_FEEDS_COUNT: "/unifiedapi/social-feeds/feeds-count",
  FETCH_SOCIAL_FEEDS_BY_ENTITY: "/unifiedapi/social-feeds/feed-by-entity",
  FETCH_SOCIAL_FEEDS_COUNT_NEW: "/unifiedapi/social-feeds/feeds-count-new",
  DOWNLOAD_TML:"/unifiedapi/social-feeds/tml-download",
  LINKEDIN_APP_CLIENT_ID: '773nbatasq9i86',
  LINKEDIN_APP_CLIENT_SECRETKEY: 'LtKqyyhXiN7qxLDh',
  //LINKEDIN_APP_CALLBACKURL: 'http://localhost/linkedin/test101.php',
  //LINKEDIN_APP_CALLBACKURL: 'https://backendportal.conceptbiu.com/assets/test101.php',
  LINKEDIN_APP_CALLBACKURL: 'http://localhost:4001/socialv2-accounts/authorizelinkedincallback',
  PRINT_LIST_COUNT : '/unifiedapi/betadev/articles/filter/data',
  REPORTNEW : "/unifiedapi/betadev/reports/filter/data",
  GET_CLIENT_MASTER_USER: "/unifiedapi/ticket/findClientMaster",
  GET_CLIENT_SUB_USER: "/unifiedapi/ticket/findClientSubUser",
  TICKET_CREATE: "/unifiedapi/tickets/addticket",
  TICKET_LIST: "/unifiedapi/tickets/getticketlist",
  REPLY_TICKET: "/unifiedapi/tickets/replyticket",
  TICKET_STATUS_UPDATE: "/unifiedapi/tickets/ticketstatus",
  TICKET_COUNT: "/unifiedapi/tickets/getticketcount",
};

export const qualitativeEnvConfig = {
  sovreportbytrend: `${process.env.REACT_APP_API_URLs}/api/sovreportbytrend`,
  sovreport: `${process.env.REACT_APP_API_URLs}/api/sovreport`,
  sovreportsnapshots: `${process.env.REACT_APP_API_URLs}/api/sovreportsnapshots`,
  storyPartreporttrendwise: `${process.env.REACT_APP_API_URLs}/api/storyPartreporttrendwise`,
  thematicreportthemewise: `${process.env.REACT_APP_API_URLs}/api/thematicreportthemewise`,
  thematicreportwithtopic: `${process.env.REACT_APP_API_URLs}/api/thematicreportwithtopic`,
  thematicreportthemewisespread: `${process.env.REACT_APP_API_URLs}/api/thematicreportthemewisespread`,
  geolocationzonalspreadarticle: `${process.env.REACT_APP_API_URLs}/api/geolocationreptzonalspreadarticle`,
  geolocationzonalspreadindex: `${process.env.REACT_APP_API_URLs}/api/geolocationreptzonalspreadindex`,
  geolocationzonewisearticle: `${process.env.REACT_APP_API_URLs}/api/geolocationreptzonewisearticle`,
  geolocationzonewisetoppublication: `${process.env.REACT_APP_API_URLs}/api/geolocationreptzonetoppubl`,
  geolocationzonesovindex: `${process.env.REACT_APP_API_URLs}/api/geolocationreptzonesovindex`,
  geolocationmarketspread: `${process.env.REACT_APP_API_URLs}/api/geolocationreptmarketspread`,
  journalisrptindexwise: `${process.env.REACT_APP_API_URLs}/api/journalisrptindexwise`,
  journalisrpttrendwise: `${process.env.REACT_APP_API_URLs}/api/journalisrpttrendwise`,
  journalisrptsentimentwise: `${process.env.REACT_APP_API_URLs}/api/journalisrptsentimentwise`,
  sentimenteportcomptetitionindex: `${process.env.REACT_APP_API_URLs}/api/sentimenteportcomptetitionindex`,
  sentimenteportcomptetitiontrend: `${process.env.REACT_APP_API_URLs}/api/sentimenteportcomptetitiontrend`,
  keywordreportindex: `${process.env.REACT_APP_API_URLs}/api/keywordeportindex`,
  keywordreporttrend: `${process.env.REACT_APP_API_URLs}/api/keywordeporttrend`,
  keywordreportsentiment: `${process.env.REACT_APP_API_URLs}/api/keywordeportsentiment`,
  geolocationcitywisearticle: `${process.env.REACT_APP_API_URLs}/api/geolocationreptcitywisearticle`,
  geolocationcitytoppublication: `${process.env.REACT_APP_API_URLs}/api/geolocationreptcitytoppubl`,
  geolocationreptcitysovindex: `${process.env.REACT_APP_API_URLs}/api/geolocationreptcitysovindex`,
  publicationreptgenresplitindex: `${process.env.REACT_APP_API_URLs}/api/publicationreptgenresplitindex`, //print sov
  publicationreptpublsovindex: `${process.env.REACT_APP_API_URLs}/api/publicationreptpublsovindex`, //online sov
  publicationreptgenresplittrend: `${process.env.REACT_APP_API_URLs}/api/publicationreptgenresplittrend`,// print trend
  publicationrepttoppubltrend: `${process.env.REACT_APP_API_URLs}/api/publreptgenresplitpublicationtrend`,//online trend
  sovpubliwisetonalityreport: `${process.env.REACT_APP_API_URLs}/api/sovpubliwisetonalityreport`,//online, print tonality
  sovcitywisetonalityreport: `${process.env.REACT_APP_API_URLs}/api/sovcitywisetonalityreport`,//city tonality print
  sovcitywisetrendreport: `${process.env.REACT_APP_API_URLs}/api/sovcitywisetrendreport`,//city trend print

  generalize2levelreport: `${process.env.REACT_APP_API_URLs}/api/generalize2levelreport`,//general api
  generalize3levelreport: `${process.env.REACT_APP_API_URLs}/api/generalize3levelreport`,//general api
  generalize4levelreport: `${process.env.REACT_APP_API_URLs}/api/generaliz4levelreport`,//general api
  generalize5levelreport: `${process.env.REACT_APP_API_URLs}/api/generaliz5levelreport`,//general api


  //to be implemented:
  sentimenteportgenreindex: `${process.env.REACT_APP_API_URLs}/api/sentimenteportgenreindex`,
  spokespersonsreptindex: `${process.env.REACT_APP_API_URLs}/api/spokespersonsreptindex`,
  spokespersonsrepttrend: `${process.env.REACT_APP_API_URLs}/api/spokespersonsrepttrend`,

  //new api for all 
  generaliz4levelreport: `${process.env.REACT_APP_API_URLs}/api/generaliz4levelreport`,
  generalize3levelreport: `${process.env.REACT_APP_API_URLs}/api/generalize3levelreport`,
  generaliz5levelreport: `${process.env.REACT_APP_API_URLs}/api/generaliz5levelreport`,
  generalize6levelreport: `${process.env.REACT_APP_API_URLs}/api/generaliz6levelreport`,
  generalize7levelreport: `${process.env.REACT_APP_API_URLs}/api/generaliz7levelreport`,
  spokesperson3levelreport: `${process.env.REACT_APP_API_URLs}/api/spokesperson3levelreport`,
  spokesperson4levelreport: `${process.env.REACT_APP_API_URLs}/api/spokesperson4levelreport`,
  spokesperson5levelreport: `${process.env.REACT_APP_API_URLs}/api/spokesperson5levelreport`,

  searchprocess: `${process.env.REACT_APP_API_URLs}/api/searchprocess`,

  qualitativeSettings: `${process.env.REACT_APP_API_URLs}/api/settings`,

}